module.exports = __webpack_public_path__ + "assets/img/4.07cea010.jpg";